import FormGroup from 'views/molecules/FormGroup/FormGroup';

export default FormGroup;
